const store = {
    namespaced: true,
    state() {
        return {
            adverts: [],
            advertsAll: [],
            isDeleteDisabled: false,
        };
    },
    getters: {
        adverts: state => state.adverts,
        advertsAll: state => state.advertsAll,
        isDeleteDisabled: state => state.isDeleteDisabled,
    },
    mutations: {
        GET_ADVERTS: (state, items) => (state.adverts = items),
        GET_ADVERTS_ALL: (state, items) => (state.advertsAll = items),
        SET_IS_DELETE_DISABLED: (state, flag) => (state.isDeleteDisabled = flag),
    },
    actions: {
        setIsDeleteDisabled: ({ commit }, flag) => commit('SET_IS_DELETE_DISABLED', flag),
        setFavoritesAdverts: ({ commit }, items) => commit('GET_ADVERTS', items),
        fetchFavoritesAdverts: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'GET',
                    url: `/favorites/`,
                    headers: {
                        Authorization: `Bearer ${this.$cookies.get('AuthToken')}`,
                    },
                });
                commit('GET_ADVERTS', res.data);
                commit('GET_ADVERTS_ALL', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
        addFavoriteAdvert: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'POST',
                    url: `/favorites/`,
                    data: {
                        product_id: data?.id,
                    },
                    headers: {
                        Authorization: `Bearer ${this.$cookies.get('AuthToken')}`,
                    },
                });
                await this.dispatch('favorites/fetchFavoritesAdverts');
            } catch (error) {
                console.dir(error);
            }
        },
        setFavoritesBySortingType: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'GET',
                    url: `/api/my-favorite-adverts/?category=${data.id}`,
                });
                commit('GET_ADVERTS', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
        deleteFavoriteAdvert: async function ({ commit }, data) {
            commit('SET_IS_DELETE_DISABLED', true);
            try {
                const res = await this.$axios({
                    method: 'DELETE',
                    url: `/favorites/`,
                    data: {
                        product_id: data?.id,
                    },
                    headers: {
                        Authorization: `Bearer ${this.$cookies.get('AuthToken')}`,
                    },
                });
                await this.dispatch('favorites/fetchFavoritesAdverts');
            } catch (error) {
                console.dir(error);
            }
            commit('SET_IS_DELETE_DISABLED', false);
        },
        deleteAllAdverts: async function ({ commit }) {
            try {
                const res = await this.$axios({
                    method: 'DELETE',
                    url: `/favorites/`,
                    data: {
                        clear_all: true,
                    },
                    headers: {
                        Authorization: `Bearer ${this.$cookies.get('AuthToken')}`,
                    },
                });
                commit('GET_ADVERTS', []);
                commit('GET_ADVERTS_ALL', []);
            } catch (error) {
                console.dir(error);
            }
        },
    },
};

export default store;
